module.exports = __webpack_public_path__ + "static/media/register-bg.4b8c70a3.jpg";